/**
 * Schattenbetrieb des Versandroutings (R118) im Auftragsdetail: „StoreOS hätte gewählt: … weil …“.
 * Ändert nichts am Versand. Rolle lager sieht nur Differenzen zur gewählten Option, keine Vertragspreise (R117).
 */
import { useQuery } from '@tanstack/react-query';
import type { Kandidat, KandidatLager, VersandEntscheidungSicht } from '@storeos/contracts';
import { versandwahl } from '../api/versandrouting';
import { datum, euro } from './format';

const PHASE_TEXT: Record<string, string> = { vorlaeufig: 'beim Import, vorläufig', endgueltig: 'nach dem Gewicht, endgültig', override: 'Override', nachtrag: 'Nachtrag' };

function betrag(k: Kandidat | KandidatLager): string {
  if ('summe_cents' in k && k.summe_cents !== undefined) return euro(k.summe_cents);
  if ('differenz_cents' in k && k.differenz_cents !== undefined) return k.differenz_cents === 0 ? 'gewählt bzw. gleich teuer' : `+${euro(k.differenz_cents)}`;
  return '';
}

function Entscheidung({ e }: { e: VersandEntscheidungSicht }) {
  return (
    <div className="versandwahl hinweis-box" data-testid="versandwahl">
      <p>
        <strong>StoreOS hätte gewählt: {e.option_name ?? 'keine zulässige Option'}</strong>
        {e.versandtag && <> · Abholung {datum(e.versandtag)}</>}
        {e.summe_cents !== undefined && e.summe_cents !== null && <> · {euro(e.summe_cents)}</>}
        <small className="hinweis"> ({PHASE_TEXT[e.phase] ?? e.phase}; Schattenbetrieb, nicht wirksam)</small>
      </p>
      <p className="hinweis">Weil: {e.grund}</p>
      <p className="hinweis">Heutiger Weg: {e.heute.text}{e.heute.option_code ? (e.abweichung ? ' · weicht ab' : ' · gleich') : ''}</p>
      <details>
        <summary>Alle Optionen</summary>
        <ul>
          {e.kandidaten.map((k) => (
            <li key={k.option_code}>
              {k.option_name}: {k.zulaessig ? betrag(k) : `ausgeschlossen, ${k.ausschluss?.text ?? ''}`}
              {k.hinweise.length > 0 && <small className="hinweis"> ({k.hinweise.join('; ')})</small>}
            </li>
          ))}
        </ul>
      </details>
    </div>
  );
}

export function VersandwahlSchatten({ sendungId }: { sendungId: string }) {
  const q = useQuery({ queryKey: ['versandwahl', sendungId], queryFn: () => versandwahl(sendungId), retry: false });
  const e = q.data?.entscheidungen[0];
  if (!e) return null;
  return <Entscheidung e={e} />;
}
